import { Sidebar } from '../components/Sidebar';
import { useGlobalOpsi } from "../components/GlobalOpsi";
import { backendPort } from '../components/Fungsiku'; 
import { Dashboard } from './Dashboard';
import { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router';
import api from "../services/axiosInstance";
import { jwtDecode } from 'jwt-decode';
import { useNotification } from './NotifPopup';
import { clearSessionToken, getSessionToken } from '../services/authSession';
import { PageKonten1 } from './Page1';
import { PageKonten2 } from './Page2'; 
import { PageKonten3 } from './Page3'; 
import { PageKonten4 } from './Page4';
import { PageKonten5 } from './Page5';
import { PageKonten6 } from './Page6_NavAtribute';
import { PageKonten13 } from './Page13';
import { PageKonten15 } from './Page15_OTF';
import { PageKonten23 } from './Page23_INV';
import { PageKonten9 } from './Page9';
import { PageKonten9_Show } from './Page9_Show';
import { AdminPage } from './AdminPage';   
import { PageKonten9_Edit } from './Page9_Edit';
import { PageKonten33_Laporan } from './Page33_Laporan';
import { PageKonten34_ShowDataLaporan } from './Page34_ShowDataLaporan';
import { PageKonten28_BanShow } from './Page28_BanShow';
import { buildMtShowData } from './mtShowDataBuilder';

export default function Main() {
  const LAPTOP_MIN_WIDTH = 600;
  const token = getSessionToken();

  const { globalOpsi, manualResyncGlobalOpsi } = useGlobalOpsi();
  const { showNotif } = useNotification();
  const opsiCabang = globalOpsi.opsiCabang ?? [];
  const opsiBan = globalOpsi.opsiBan ?? [];
  
  const authIdentity = useMemo(() => {
    if (!token) return {};
    try {
      const decoded = jwtDecode(token);
      const tokenUsername = String(
        decoded?.username
        ?? decoded?.user_name
        ?? decoded?.preferred_username
        ?? decoded?.sub
        ?? ''
      ).trim();
      return {
        id: Number(decoded?.id || 0),
        username: tokenUsername,
        nama: String(decoded?.nama ?? '').trim(),
        jabatan: String(decoded?.jabatan || "").trim(),
        kode_cabang: String(decoded?.kode_cabang || "").trim(),
        user_level: Number.isFinite(Number(decoded?.user_level)) ? Number(decoded?.user_level) : null,
        exp: Number(decoded?.exp || 0),
      };
    } catch (_err) {
      return {};
    }
  }, [token]);

  useEffect(() => {
    if (!token) return;
    try {
      const decoded = jwtDecode(token);
      console.log('[DEBUG AUTH TOKEN] decoded payload:', {
        id: decoded?.id,
        username: decoded?.username,
        nama: decoded?.nama,
        jabatan: decoded?.jabatan,
        kode_cabang: decoded?.kode_cabang,
        user_level: decoded?.user_level,
        exp: decoded?.exp,
      });
      console.log('[DEBUG AUTH TOKEN] normalized identity:', authIdentity);
    } catch (err) {
      console.error('[DEBUG AUTH TOKEN] gagal decode token:', err);
    }
  }, [token, authIdentity]);
  const [page, setPage] = useState("Dashboard");
  const [pendingRequestCount, setPendingRequestCount] = useState(0);
  const reloadToken = 0;
  const [isMobileBlocked, setIsMobileBlocked] = useState(
    typeof window !== "undefined" ? window.innerWidth < LAPTOP_MIN_WIDTH : false
  );
  const [showDownloadAndroidModal, setShowDownloadAndroidModal] = useState(false);
  const navigate = useNavigate();
  const logout = ()=>{setShowConfirmLogOut(true)};
  const [showConfirmLogOut, setShowConfirmLogOut] = useState(false);
  const prevPageRef = useRef("Dashboard");
  const dashboardPickerState = (typeof window !== "undefined" && window.__dashboard_picker_state)
    ? window.__dashboard_picker_state
    : {};
  const dashboardPickerMtId = String(dashboardPickerState?.id_mt || '').trim();
  const dashboardPickerSourcePage = String(dashboardPickerState?.source_page || '').trim();
  const dashboardPickerMtRow = dashboardPickerState?.mt_row && typeof dashboardPickerState.mt_row === 'object'
    ? dashboardPickerState.mt_row
    : null;
  const mtShowData = buildMtShowData({
    dashboardPickerMtId,
    dashboardPickerMtRow,
    opsiMT: globalOpsi?.opsiMT,
  });

  useEffect(() => {
    const checkViewport = () => {
      if (typeof window === "undefined") return;
      setIsMobileBlocked(window.innerWidth < LAPTOP_MIN_WIDTH);
    };
    checkViewport();
    window.addEventListener("resize", checkViewport);
    window.addEventListener("orientationchange", checkViewport);
    return () => {
      window.removeEventListener("resize", checkViewport);
      window.removeEventListener("orientationchange", checkViewport);
    };
  }, []);

  useEffect(() => {
    const unsubscribe = api.subscribePendingRequests((count) => {
      setPendingRequestCount(Number(count || 0));
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const prev = prevPageRef.current;
    const isPrevReportFlow = prev === "Page33" || prev === "Page34";
    const isNextReportFlow = page === "Page33" || page === "Page34";
    if (isPrevReportFlow && !isNextReportFlow) {
      if (typeof window !== "undefined") {
        window.__laporan_runtime_state = {};
      }
    }
    prevPageRef.current = page;
  }, [page]);

  useEffect(() => {
    if (!token) {
      navigate('/login', { replace: true });
      return;
    }

    if (!authIdentity || !authIdentity.exp) {
      const err = new Error('Token tidak valid');
      console.error('Token tidak valid', err);
      clearSessionToken();
      navigate('/login', { replace: true });
      return;
    }
    const expMs = Number(authIdentity?.exp || 0) * 1000;
    if (Number.isFinite(expMs) && expMs > 0) {
      const remainingMs = expMs - Date.now();
      if (remainingMs <= 0) {
        clearSessionToken();
        navigate('/login', { replace: true });
        return;
      }

      const timeoutId = setTimeout(() => {
        api.cancelPendingRequests({ reason: 'Token expired' });
        clearSessionToken();
        navigate('/login', { replace: true });
        console.log('LogOut, token sudah expired');
      }, remainingMs);

      return () => clearTimeout(timeoutId);
    }
  }, [token, navigate, authIdentity]);

  const sharedAuthProps = useMemo(() => ({ authIdentity }), [authIdentity]);

  //handleBack
  useEffect(() => {
    /*handle back*/
    const handleBack = (event) => {
      event.preventDefault();
      setShowConfirmLogOut(true);
      window.history.pushState(null, "", window.location.pathname);
    };

    window.history.pushState(null, "", window.location.pathname);
    window.addEventListener("popstate", handleBack);

    return () => {
    window.removeEventListener("popstate", handleBack);
    };

  },[]);

  const handleRefresh = async () => {
    const requestGroup = 'master-sync';
    api.cancelPendingRequests({ group: requestGroup, reason: 'Refresh requested by user' });
    try {
      await manualResyncGlobalOpsi({ requestGroup });
      showNotif('success', 'Syncronize berhasil');
    } catch (err) {
      console.error(err);
      if (api.isCanceledError(err)) {
        showNotif('info', 'Syncronize sebelumnya dihentikan. Memulai ulang data...');
      } else {
        showNotif('error', 'Syncronize gagal');
      }
    }
  };
    
  const confirmLogout = () => {
    api.post(`${backendPort}/api/auth/logout`).catch(() => {});
    clearSessionToken();
    navigate("/", { replace: true });
  };
  const handleStopPendingProcess = async () => {
    try {
      const total = Number(api.getPendingRequestCount() || 0);
      if (total <= 0) {
        showNotif("info", "Tidak ada proses pending untuk dihentikan.");
        return;
      }
      api.cancelPendingRequests({ reason: "Stopped by user" });
      showNotif("success", `STOP: ${total} proses pending berhasil dihentikan.`);
    } catch (err) {
      console.error(err);
      showNotif("error", "STOP gagal dijalankan.");
    }
  };

  const handleOpenDownloadAndroidModal = () => {
    setShowDownloadAndroidModal(true);
  };

  const handleCloseDownloadAndroidModal = () => {
    setShowDownloadAndroidModal(false);
  };

  const handleDownloadAndroidApk = () => {
    setShowDownloadAndroidModal(false);
    const apkUrl = `${backendPort}/appandroid/pua-absensi.apk`;
    if (typeof window !== "undefined") {
      window.location.href = apkUrl;
    }
  };

  const topFabStyle = {
    width: 42,
    height: 42,
    borderRadius: 999,
    border: "1px solid rgba(255,255,255,0.35)",
    background: "rgba(15, 23, 42, 0.38)",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    color: "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0.92,
    boxShadow: "0 8px 24px rgba(2,6,23,0.18)",
  };

  let content;
  switch(page) {
    case "Dashboard": content = <Dashboard setPage={setPage} globalOpsi={globalOpsi} token={token} manualResyncGlobalOpsi={manualResyncGlobalOpsi} {...sharedAuthProps} />; break;
    case "Page1": content = <PageKonten1 globalOpsi={globalOpsi} token={token} {...sharedAuthProps} />; break;
    case "Page2": content = <PageKonten2 globalOpsi={globalOpsi} token={token} {...sharedAuthProps} />; break;
    case "Page3": content = <PageKonten3 globalOpsi={globalOpsi} token={token} {...sharedAuthProps} />; break;
    case "Page4": content = <PageKonten4 globalOpsi={globalOpsi} token={token} {...sharedAuthProps} />; break;
    case "Page5": content = <PageKonten5 globalOpsi={globalOpsi} token={token} {...sharedAuthProps} />; break;
    case "Page6": content = <PageKonten6 globalOpsi={globalOpsi} token={token} onMasterChanged={manualResyncGlobalOpsi} {...sharedAuthProps} />; break;
    case "Page9": content = <PageKonten9 globalOpsi={globalOpsi} setPage={setPage} reloadToken={reloadToken} {...sharedAuthProps} />; break;
    case "Page9_Show":
      content = mtShowData
        ? (
          <PageKonten9_Show
            globalOpsi={globalOpsi}
            editData={mtShowData}
            setShowDetail={(open) => {
              if (!open) {
                const returnPage = dashboardPickerSourcePage || "Dashboard";
                if (typeof window !== "undefined") {
                  const prev = window.__dashboard_picker_state || {};
                  window.__dashboard_picker_state = { ...prev, id_mt: "", mt_row: null, source_page: "" };
                }
                setPage(returnPage);
              }
            }}
            setShowMaster={() => {}}
            reloadToken={reloadToken}
          />
        )
        : <>Data MT tidak ditemukan.</>;
      break;
    case "Page9_Edit": content = <PageKonten9_Edit setPage={setPage} reloadToken={reloadToken} {...sharedAuthProps} />; break;
    case "Page13": content = <PageKonten13 globalOpsi={globalOpsi} token={token} {...sharedAuthProps} />; break;
    case "Page15": content = <PageKonten15 globalOpsi={globalOpsi} token={token} setPage={setPage} resendToken={reloadToken} {...sharedAuthProps} />; break;
    case "Page23": content = <PageKonten23 globalOpsi={globalOpsi} token={token} setPage={setPage} resendToken={reloadToken} {...sharedAuthProps} />; break;
    case "Page28": content = <PageKonten28_BanShow globalOpsi={globalOpsi} idBan={Number(dashboardPickerState?.id_ban || 0)} reloadToken={reloadToken} />; break;
    case "Admin": content = <AdminPage token={token} opsiCabang={opsiCabang} {...sharedAuthProps} />; break;
    case "Page33": content = <PageKonten33_Laporan opsiCabang={opsiCabang} setPage={setPage} {...sharedAuthProps} />; break;
    case "Page34": content = <PageKonten34_ShowDataLaporan setPage={setPage} opsiCabang={opsiCabang} opsiBan={opsiBan} globalOpsi={globalOpsi} {...sharedAuthProps} />; break;
    default: content = <>Halaman Tidak Ditemukan</>;
  }
  //if (isMobileBlocked) {
  if (false) {  
    return (
      <>
        {showDownloadAndroidModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
            <div className="bg-white text-slate-900 p-4 rounded w-96">
              <h5 className="mb-2 font-semibold">Konfirmasi Download</h5>
              <p className="mb-3">Download aplikasi <b>pua-absensi.apk</b>?</p>
              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={handleCloseDownloadAndroidModal}
                >
                  Batal
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleDownloadAndroidApk}
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        )}
        <div
          className="d-flex align-items-center justify-content-center text-center"
          style={{ minHeight: "100vh", padding: "2rem", background: "#f8fafc" }}
        >
          <div className="card shadow-sm border-0" style={{ maxWidth: 560, width: "100%" }}>
            <div className="card-body p-4 p-md-5">
              <h4 className="mb-3">Download ABSENSI TMS</h4>
              <p className="text-muted mb-4">
                Klik link dibawah ini untuk download aplikasi android absensi pegawai.
              </p>
              <div>
              <button
                className="btn btn-primary"
                onClick={handleOpenDownloadAndroidModal}
              >
                Download ABSENSI TMS for Android
              </button>
              </div>
              
              <div className='pt-2'>
              <button
                className="btn btn-secondary"
                onClick={() => {
                  api.post(`${backendPort}/api/auth/logout`).catch(() => {});
                  clearSessionToken();
                  navigate("/", { replace: true });
                }}
              >
                Keluar
              </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <div>
    {showDownloadAndroidModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
        <div className="bg-white text-slate-900 p-4 rounded w-96">
          <h5 className="mb-2 font-semibold">Konfirmasi Download</h5>
          <p className="mb-3">Download aplikasi <b>pua-absensi.apk</b>?</p>
          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={handleCloseDownloadAndroidModal}
            >
              Batal
            </button>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={handleDownloadAndroidApk}
            >
              Download
            </button>
          </div>
        </div>
      </div>
    )}
    {true && (
      <div
        className="d-flex gap-2"
        style={{
          position: "fixed",
          top: 10,
          right: 16,
          zIndex: 12000
        }}
      >
        {page !== "Dashboard" && pendingRequestCount > 0 && (
          <button
            onClick={handleStopPendingProcess}
            style={topFabStyle}
            aria-label="STOP"
            title={`STOP (${pendingRequestCount})`}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <rect x="6" y="6" width="12" height="12" rx="2" ry="2" />
            </svg>
          </button>
        )}
        {page !== "Dashboard" && (
          <>
            <button
              onClick={handleRefresh}
              style={topFabStyle}
              aria-label="RESYNC"
              title="REFRESH CACHE"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M21 2v6h-6" />
                <path d="M3 12a9 9 0 0 1 15.2-6.36L21 8" />
                <path d="M3 22v-6h6" />
                <path d="M21 12a9 9 0 0 1-15.2 6.36L3 16" />
              </svg>
            </button>
            <button
              onClick={() => { setPage("Dashboard"); }}
              style={topFabStyle}
              aria-label="BACK"
              title="BACK"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="m15 18-6-6 6-6" />
                <path d="M21 12H9" />
              </svg>
            </button>
          </>
        )}
      </div>
    )}
    <div className="flex h-screen bg-gray-50">
      <Sidebar onChangePage={setPage} onLogOut={logout} onOpenDownloadModal={handleOpenDownloadAndroidModal} {...sharedAuthProps}/>
      <main className="flex-1 overflow-y-auto">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center ps-2 pe-4 py-2">
          <div className="flex-grow-1"></div>
      </div>

        {/* Konten */}
        <div className="px-4 py-2">
          {content}
      </div>
      </main>
    </div>
    <div>
    {showConfirmLogOut && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
    <div className="bg-white p-4 rounded w-96">
      <h5>Konfirmasi</h5>
      <p>Anda yakin ingin keluar?</p>
      <div className="flex justify-end gap-2 mt-3">
        <button
          className="btn btn-secondary"
          onClick={() => {setShowConfirmLogOut(false);}}
        >
          Tidak
        </button>
        <button
          className="btn btn-danger"
          onClick={confirmLogout}
        >
          Ya, Keluar
        </button>
      </div>
    </div>
  </div>
      )}
      </div>
    </div>
  );
}
